import React from 'react';

interface AnimatedNumberProps extends React.HTMLAttributes<HTMLSpanElement> {
  end: number;
  start?: number;
  duration?: `${number}s`;
}

export function AnimatedNumber(props: AnimatedNumberProps) {
  return (
    <span
      className="animated-number"
      style={{
        '--start': props.start ?? 0,
        '--target': props.end,
        '--duration': props.duration ?? '1.2s',
      } as React.CSSProperties}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
